import axios from 'axios';
import config from '~/config';
import * as customError from '~/models/error'

export const usePropernameStore = defineStore('propername', {
    state: () => ({
        propernames: [],
        groups: [],
        groupId: null,
        isReachEnd: false,
        pageNumber: 1,
        groupsForDropSheet: [{
            Id: null,
            Title: useI18n().t('general_all'),
        }],
        // [...section].vue
        propername: {},
        aboutPropername: {},
        listAyah: {},
        listAyahItems: [],
        listAyahPageNumber: 1,
        listAyahGroupId: null,
        listAyahIsReachEnd: false,
        listAyahSurahListForDropSheet: [{
            Id: null,
            Title: useI18n().t('general_all'),
        }],

        relatedPropername: [],
        relatedPageNumber: 1,
        relatedIsReachEnd: false,
    }),
    actions: {
        async getListPropername(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Propername/ListPropername`;
                const serviceResult = await axios.get(url, { params });

                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)

                const data = serviceResult.data.Data;

                if (data?.ResultSet2) {
                    if (!this.groups.length) {
                        this.groups = data.ResultSet2;
                        this.groupsForDropSheet = this.groupsForDropSheet.concat(this.groups);
                    }
                } else {
                    this.isReachEnd = true;
                }

                if (data?.ResultSet1) {
                    this.propernames = data.ResultSet1;
                    for (let g of this.groups) {
                        (g.items && this.pageNumber != 1) ? {} : this.groups[this.groups.indexOf(g)].items = [];
                        for (let i of data.ResultSet1) {
                            i.GroupId == g.Id ? this.groups[this.groups.indexOf(this.groups.filter((e) => e.Id == g.Id)[0])].items.push(i) : {};
                        }
                    }
                } else {
                    this.isReachEnd = true;
                }

                return this.propernames;

            } catch (err) {
                console.log({ err })
            }
        },

        async getPropername(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Propername/GetPropername`;
                const serviceResult = await axios.get(url, { params });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.propername = serviceResult.data.Data;
                return this.propername;
            } catch (err) {
                console.log({ err })
            }
        },

        async getAboutPropername(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Propername/AboutPropername`;
                const serviceResult = await axios.get(url, { params });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.aboutPropername = serviceResult.data.Data;
                return this.aboutPropername;
            } catch (err) {
                console.log({ err })
            }

        },

        async getListAyah(params) {
            try {
                if (this.listAyahPageNumber == 1) {
                    this.listAyahItems = [];
                }
                const url = `${config.API_BASE_URL}/api/Propername/ListAyah`;
                const serviceResult = await axios.get(url, { params });
                if (!serviceResult?.data?.Data || !serviceResult?.data?.Data?.ResultSet2?.length)
                    throw new customError.NoContent(serviceResult, url)
                this.listAyah = serviceResult.data.Data;
                if (this.listAyahSurahListForDropSheet.length <= 1) {
                    this.listAyahSurahListForDropSheet = this.listAyahSurahListForDropSheet.concat(this.listAyah.ResultSet2);
                }
                if (serviceResult?.data?.Data?.ResultSet1?.length) {
                    this.listAyahItems = this.listAyahItems.concat(serviceResult.data.Data.ResultSet1);
                } else {
                    this.listAyahIsReachEnd = true;
                }
                return this.listAyah;
            } catch (err) {
                console.log({ err })
            }
        },

        async getListRelatedPropername(params) {
            try {
                if (this.relatedPageNumber == 1) {
                    this.relatedPropername = [];
                }
                const url = `${config.API_BASE_URL}/api/Propername/ListRelatedProperName`;
                const serviceResult = await axios.get(url, { params });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                if (serviceResult?.data?.Data?.length) {
                    this.relatedPropername = this.relatedPropername.concat(serviceResult.data.Data);
                } else {
                    this.relatedIsReachEnd = true;
                }
                return this.relatedPropername;
            } catch (err) {
                console.log({ err })
            }
        }
    }
});